module.exports = __webpack_public_path__ + "static/media/mail-box.28fa23e8.jpg";